import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem } from "reactstrap";
import { MutatingDots } from 'react-loader-spinner';
import { Link } from "react-router-dom";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "./datatables.scss";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
 const backendFileUrl = process.env.REACT_APP_BACKEND_IMAGE_URL;

const CourseRegistrationsList = (props) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  document.title = "Course Registrations List | Technical Hub - All Registrations";

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Registrations", link: "#" },
    { title: "Registrations List", link: "#" },
  ];

  const [registrationsData, setRegistrationsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [registrationToDelete, setRegistrationToDelete] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [certModal, setCertModal] = useState(false);
  const [selectedCerts, setSelectedCerts] = useState([]);
  const [syllabusModal, setSyllabusModal] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleCertModal = () => setCertModal(!certModal);

  const handleOpenList = (list, title) => {
    setSelectedData(list || []);
    setModalTitle(title);
    setModalOpen(true);
  };

  const handleOpenCertifications = (certs) => {
    setSelectedCerts(certs || []);
    setCertModal(true);
  };

  const handleOpenSlots = (slots) => {
    setSelectedData(slots || []);
    setModalTitle("Slots");
    setModalOpen(true);
  };


  useEffect(() => {
    props.setBreadcrumbItems('Course Registrations', breadcrumbItems);
    fetchRegistrationsData();
  }, []);

  const fetchRegistrationsData = async () => {
    try {
      const response = await axios.get(`${backendUrl}get-certification-data`);

      console.log(response.data);

      if (response.status === 200) {
        setRegistrationsData(response.data.data || []);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleEditRegistration = (registration) => {
    // Handle edit functionality
  }

  const toggleDeleteModal = (registration) => {
    setRegistrationToDelete(registration);
    setShowDeleteModal(!showDeleteModal);
  };

  const handleDeleteRegistration = async () => {
    try {
      if (!registrationToDelete) return;

      const response = await axios.delete(
        `${backendUrl}delete-certificate-registration/${registrationToDelete._id}`
      );

      if (response.status === 200) {
        toast.success("Registration deleted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Remove the deleted registration from the state
        setRegistrationsData(prevData =>
          prevData.filter(item => item._id !== registrationToDelete._id)
        );

        // Close the modal
        setShowDeleteModal(false);
        setRegistrationToDelete(null);
      }
    } catch (error) {
      console.log("Error deleting registration:", error);
      toast.error("Failed to delete registration. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const data = {
    columns: [
      { label: "Order", field: "order", sort: "asc", width: 50 },
      { label: "Certificate Logo", field: "certificate_logo", sort: "asc", width: 100 },
      { label: "Certificate Name", field: "certificate_name", sort: "asc", width: 150 },
      { label: "Seats", field: "seats", sort: "asc", width: 100 },
      { label: "Eligible Roll Nos", field: "roll_no", sort: "asc", width: 150 },
      { label: "Eligible Branches", field: "branch", sort: "asc", width: 150 },
      { label: "Eligible Passout Years", field: "pass_out_year", sort: "asc", width: 150 },
      { label: "Eligible colleges", field: "college", sort: "asc", width: 150 },
      { label: "Slots", field: "slots", sort: "asc", width: 150 },
      { label: "Remarks", field: "Remarks", sort: "asc", width: 100 },
      { label: "Registration End Date", field: "registration_end_date", sort: "asc", width: 150 },
      { label: "Status", field: "status", sort: "asc", width: 100 },
      { label: "Actions", field: "actions", sort: "asc", width: 150 },
    ],
    rows: Array.isArray(registrationsData) && registrationsData.length > 0
      ? registrationsData.map((registration, index) => ({
        order: index + 1,
        certificate_logo: registration?.certificate_logo ? (
          <img
            src={`${backendFileUrl}certification-icons/${registration.certificate_logo}`}
            alt="Certificate Logo"
            style={{ width: "50px", height: "50px", objectFit: "contain" }}
          />
        ) : "N/A",
        certificate_name: registration?.certificate_name || "N/A",
        seats: registration?.seats || 0,
        roll_no: (
          <Button
            size="sm"
            color="secondary"
            onClick={() =>
              handleOpenList(registration.eligible_rollNos, "Eligible Roll Nos")
            }
          >
            View ({registration.eligible_rollNos?.length || 0})
          </Button>
        ),
        branch: (
          <Button
            size="sm"
            color="info"
            onClick={() =>
              handleOpenList(registration.eligible_branch, "Eligible Branches")
            }
          >
            View ({registration.eligible_branch?.length || 0})
          </Button>
        ),
        pass_out_year: (
          <Button
            size="sm"
            color="warning"
            onClick={() =>
              handleOpenList(registration.eligible_passoutyear, "Eligible Passout Years")
            }
          >
            View ({registration.eligible_passoutyear?.length || 0})
          </Button>
        ),
        college: (
          <Button
            size="sm"
            color="primary"
            onClick={() =>
              handleOpenList(registration.eligible_college, "Eligible Colleges")
            }
          >
            View ({registration.eligible_college?.length || 0})
          </Button>
        ),
        slots: (
          <Button
            size="sm"
            color="success"
            onClick={() =>
              handleOpenSlots(registration.slots)
            }
          >
            View ({registration.slots?.length || 0})
          </Button>
        ),
        Remarks: registration?.Remarks || "N/A",
        registration_end_date: registration?.end_date
          ? dayjs(registration.end_date).tz("Asia/Kolkata").format("YYYY-MM-DD")
          : "N/A",
        status: registration?.status === 1 ? "Active" : "Inactive",
        actions: (
          <div>
            <Link
              to={`/edit-certification-registration/${registration._id}`}
              className="btn btn-info btn-sm me-2"
              onClick={() => handleEditRegistration(registration)}
            >
              Edit
            </Link>
            <Button
              color="danger"
              size="sm"
              className="me-2"
              onClick={() => toggleDeleteModal(registration)}
            >
              Delete
            </Button>
          </div>
        ),
      }))
      : [],
  };

  return (
    <React.Fragment>
      <Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <Col className="col-12">
          <Card>
            <CardBody className="d-flex justify-content-between align-items-center">
              <CardTitle className="h4">Course Registrations List</CardTitle>
              <Link to="/add-certifications">
                <Button type="button" color="primary" className="waves-effect waves-light">Add Registration</Button>
              </Link>
            </CardBody>
            <CardBody>
              {loading ? (
                <div className="row">
                  <div className="col-md-2 offset-5">
                    <MutatingDots
                      visible={true}
                      height="100"
                      width="100"
                      color="#2B3A4A"
                      secondaryColor="#2B3A4A"
                      radius="12.5"
                      ariaLabel="mutating-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                </div>
              ) : (
                <MDBDataTable responsive bordered data={data} noBottomColumns />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal isOpen={showDeleteModal} toggle={() => toggleDeleteModal(null)}>
        <ModalHeader toggle={() => toggleDeleteModal(null)}>Delete Registration</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this registration?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => toggleDeleteModal(null)}>Cancel</Button>
          <Button color="danger" onClick={handleDeleteRegistration}>Delete</Button>
        </ModalFooter>
      </Modal>

      {/* Generic List Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{modalTitle}</ModalHeader>
        <ModalBody>
          {modalTitle === "Slots" && selectedData?.length > 0 ? (
            <div>
              {selectedData.map((slot, index) => (
                <Card key={index} className="mb-2">
                  <CardBody>
                    <p><strong>Slot:</strong> {slot.slot}</p>
                    <p><strong>Capacity:</strong> {slot.capacity}</p>
                    <p><strong>Time:</strong> {slot.time}</p>
                    <p><strong>Days:</strong> {slot.days || slot.day}</p>
                  </CardBody>
                </Card>
              ))}
            </div>
          ) : selectedData?.length > 0 ? (
            <ul>
              {selectedData.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>No data available</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>Close</Button>
        </ModalFooter>
      </Modal>

      {/* Syllabus Modal */}

    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CourseRegistrationsList);
